import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AIImageGenerationPage = lazy(() => import('../pages/services/ai-image-generation/page'));
const AIVideoGenerationPage = lazy(() => import('../pages/services/ai-video-generation/page'));
const HybridContentPage = lazy(() => import('../pages/services/hybrid-ai-content/page'));
const UGCContentPage = lazy(() => import('../pages/services/ugc-content/page'));
const InsightsPage = lazy(() => import('../pages/insights/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/ai-image-generation',
    element: <AIImageGenerationPage />,
  },
  {
    path: '/services/ai-video-generation',
    element: <AIVideoGenerationPage />,
  },
  {
    path: '/services/hybrid-ai-content',
    element: <HybridContentPage />,
  },
  {
    path: '/services/ugc-content',
    element: <UGCContentPage />,
  },
  {
    path: '/insights',
    element: <InsightsPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
